<template>
  <el-card shadow="always" body-style="padding:0px;width:100%;display: flex;">
    <el-form :inline="true" style="position: absolute; top: 5px; left: 20px; z-index: 50">
      <el-form-item label="年度" style="margin-bottom: 0px">
        <el-select
          v-model="targetyear"
          placeholder="请选择"
          size="mini"
          style="width: 80px"
          @change="changeAndRedraw()">
          <el-option v-for="item in yearsOptions" :key="item" :label="item" :value="item"> </el-option>
        </el-select>
      </el-form-item>
      <el-form-item label="省局" style="margin-left: 10px; margin-bottom: 0px">
        <el-select
          v-model="targetprovince"
          multiple
          collapse-tags
          placeholder="请选择"
          size="mini"
          style="width: 300px">
          <el-option v-for="item in provinceOptions" :key="item" :label="item" :value="item"> </el-option>
        </el-select>
      </el-form-item>
      <el-form-item label="排名" style="margin-left: 10px; margin-bottom: 0px">
        <el-select v-model="targetlimit" placeholder="请选择" size="mini" style="width: 80px">
          <el-option v-for="item in limitsOptions" :key="item.value" :label="item.text" :value="item.value">
          </el-option>
        </el-select>
      </el-form-item>
      <el-button type="primary" size="mini" style="margin-top: 7px" @click="initChatOptionData()">搜索</el-button>
    </el-form>
    <div id="chart_province_2" style="height: 860px; width: 50%"></div>
    <div id="chart_province_2_table" class="echart_table">
      <div style="width: 100%; height: 34px; line-height: 34px" class="text-warning">
        <div style="width: 60px; float: left; text-align: center">
          <i
            @click="downloadData('chart_province_2_html')"
            class="fa fa-download searchFilerCls"
            aria-hidden="true"
            title="导出"></i>
        </div>
        <el-row :gutter="15" style="width: calc(100% - 60px); float: left">
          <el-col :span="8">
            <el-input
              v-model="query['chart_province_2'].name"
              clearable
              size="mini"
              placeholder="请输入出版单位名称"
              class="searchInput">
            </el-input>
          </el-col>
          <el-col :span="2">
            <el-button @click="goFilterList('chart_province_2')" size="mini" icon="el-icon-search"></el-button>
          </el-col>
        </el-row>
      </div>
      <table id="chart_province_2_tab" class="tabletemp table-striped table-bordered tabletemp-hover">
        <thead>
          <tr title="返回">
            <th style="width: 30px">
              <div class="th-inner" @click="backEcharts('chart_province_2')">
                <i class="fa fa-mail-reply" style="font-size: 16px; color: #55d3d3"></i>
              </div>
              <div class="fht-cell"></div>
            </th>
            <th nowrap="nowrap" style="width: 190px">
              <div class="th-inner text-warning">省局</div>
            </th>
            <th nowrap="nowrap" style="width: 230px">
              <div class="th-inner text-warning">出版单位</div>
            </th>
            <th nowrap="nowrap">
              <div class="th-inner text-warning">
                {{ this.table2colname }}
              </div>
            </th>
          </tr>
        </thead>
        <tbody id="chart_province_2_html" style="font-size: 14px !important">
          <tr>
            <td style="text-align: center; vertical-align: middle" colspan="99">加载中...</td>
          </tr>
        </tbody>
      </table>
    </div>

    <div id="chart_province_3" style="height: 860px; width: 50%"></div>
    <div id="chart_province_3_table" class="echart_table">
      <div style="width: 100%; height: 34px; line-height: 34px" class="text-warning">
        <div style="width: 60px; float: left; text-align: center">
          <i
            @click="downloadData('chart_province_3_html')"
            class="fa fa-download searchFilerCls"
            aria-hidden="true"
            title="导出"></i>
        </div>
        <el-row :gutter="15" style="width: calc(100% - 60px); float: left">
          <el-col :span="8">
            <el-input
              v-model="query['chart_province_3'].name"
              clearable
              size="mini"
              placeholder="请输入出版单位名称"
              class="searchInput">
            </el-input>
          </el-col>
          <el-col :span="2">
            <el-button @click="goFilterList('chart_province_3')" size="mini" icon="el-icon-search"></el-button>
          </el-col>
        </el-row>
      </div>
      <table id="chart_province_3_tab" class="tabletemp table-striped table-bordered tabletemp-hover">
        <thead>
          <tr title="返回">
            <th style="width: 30px">
              <div class="th-inner" @click="backEcharts('chart_province_3')">
                <i class="fa fa-mail-reply" style="font-size: 16px; color: #55d3d3"></i>
              </div>
              <div class="fht-cell"></div>
            </th>
            <th nowrap="nowrap" style="width: 190px">
              <div class="th-inner text-warning">省局</div>
            </th>
            <th nowrap="nowrap" style="width: 230px">
              <div class="th-inner text-warning">出版单位</div>
            </th>
            <th nowrap="nowrap">
              <div class="th-inner text-warning">
                {{ this.table3colname }}
              </div>
            </th>
          </tr>
        </thead>
        <tbody id="chart_province_3_html" style="font-size: 14px !important">
          <tr>
            <td style="text-align: center; vertical-align: middle" colspan="99">加载中...</td>
          </tr>
        </tbody>
      </table>
    </div>
  </el-card>
</template>

<script>
import * as echarts from "echarts";
const XLSX = require("xlsx");
import vintage from "echarts/theme/vintage.js";
import macarons from "echarts/theme/macarons.js";
import macarons2 from "echarts/theme/macarons2.js";
import blue from "echarts/theme/blue.js";
import cool from "echarts/theme/cool.js";
import forest from "echarts/theme/forest.js";
import fruit from "echarts/theme/fruit.js";
import green from "echarts/theme/green.js";
import roma from "echarts/theme/roma.js";
import shine from "echarts/theme/shine.js";
import london from "echarts/theme/london.js";
import infographic from "echarts/theme/infographic.js";

import { getProvinceFinanceChart, getProvinceFinanceDetail } from "../../api/adminRole/statisticsAnalysis";
import { isEmpty } from "validate.js";
import moment from "moment";
export default {
  data() {
    return {
      imgUrlfdj: "image:///static/fdj.png",
      imgUrldata: "image:///static/list_ico.png",
      imgUrldownload: "image:///static/download.png",

      yearsOptions: [2017, 2018, 2019, 2020, 2021, 2022, 2023, 2024],
      provinceOptions: [],
      limitsOptions: [
        { text: "前10", value: 10 },
        { text: "前20", value: 20 },
        { text: "全部", value: 0 },
      ],
      searchFirstYear: 2023, // 被坑了，之前是2021，未来可能统一改
      targetyear: 2024,
      targetprovince: [],
      targetlimit: 0,

      table1colname: "音像",
      table2colname: "音像",
      table3colname: "音像",
      datalist: [],

      queryVisible: {
        chart_province_1: false,
        chart_province_2: false,
        chart_province_3: false,
      },
      query: {
        chart_province_1: {
          provincename: "",
          name: "",
          value: "",
        },
        chart_province_2: {
          provincename: "",
          name: "",
          value: "",
        },
        chart_province_3: {
          provincename: "",
          name: "",
          value: "",
        },
      },
      bakData: {},

      chartDataBase: [],
      chartDataFinance: [],
    };
  },
  props: ["chartTheme", "activeName"],
  watch: {
    chartTheme: {
      handler(val) {
        this.chartTheme = val;
        console.log("chartTheme====", this.activeName);
        if (this.activeName == "business") {
          setTimeout(
            function () {
              this.initChatOptionData();
            }.bind(this),
            1000
          );
        }
      },
      immediate: true,
    },
    activeName: {
      handler(val) {
        if (val == "business") {
          var myChart = echarts.init(document.getElementById("chart_province_2"), this.chartTheme);
          this.chartResize(myChart);
          var myChart = echarts.init(document.getElementById("chart_province_3"), this.chartTheme);
          this.chartResize(myChart);
        }
      },
      immediate: true,
    },
  },
  methods: {
    async downloadData(id) {
      var columns = { provincename: "省局", name: "出版单位", value: this.category };
      let cellWidths = [{ wpx: 270 }, { wpx: 300 }, { wpx: 150 }];
      var list = [];
      for (var i in this.datalist) {
        var po = this.datalist[i];
        var data = {};
        for (var key in columns) {
          data[columns[key]] = po[key];
        }
        list.push(data);
      }
      var filename = `${this.targetyear}年${this.category}_${moment()}.xlsx`;
      var opts = Object.values(columns);
      var wsname = "Sheet1";
      const wb = XLSX.utils.book_new();
      const ws = await XLSX.utils.json_to_sheet(list, opts);
      ws["!cols"] = cellWidths;
      XLSX.utils.book_append_sheet(wb, ws, wsname);
      await XLSX.writeFile(wb, `${filename}`);
    },
    initCharts() {
      this.goSearchBusinessCharts();
    },
    createDataHtml(id, datalist) {
      console.log("createDataHtml====", id, datalist);
      let html = "";
      for (var index in datalist) {
        var item = datalist[index];
        html += '<tr data-index="0">';
        html +=
          ' <td style="text-align: center; vertical-align: middle;width:30px;padding: 0.74rem;">' +
          (Number(index) + 1) +
          "</td>";
        html +=
          ' <td style="text-align: left; vertical-align: middle;width: 190px;padding: 0.74rem;">' +
          item.provincename +
          "</td>";
        html +=
          ' <td style="text-align: left; vertical-align: middle;width: 230px;padding: 0.74rem;">' + item.name + "</td>";
        html +=
          ' <td style="text-align: left; vertical-align: middle;padding: 0.74rem;">' +
          this.formatEmpty(item.value) +
          "</td>";
        html += "</tr>";
      }
      $("#" + id + "_html").html(html);
    },
    disposeChart(id) {
      var obj = document.getElementById(id);
      if (obj != null) {
        echarts.dispose(obj);
      }
    },
    goSearchBusinessCharts() {
      var that = this;
      getProvinceFinanceChart({ firstyear: this.searchFirstYear }).then((res) => {
        console.log("getProvinceFinanceChart====", res);
        that.chartDataBase = res.base;
        that.chartDataFinance = res.finance;

        var provinceOptions = [];
        if (that.chartDataBase.length > 0) {
          // 一般是两组 音像一组 电子一组
          for (var record of this.chartDataBase) {
            provinceOptions.push(record.provincename);
          }

          that.provinceOptions = provinceOptions;
          if (that.targetprovince.length == 0) {
            that.targetprovince = [...provinceOptions];
          }
        }

        setTimeout(function () {
          that.initChatOptionData();
        }, 1000);
      });
    },
    initChatOptionData() {
      var that = this;
      var baseYear = that.targetyear; // 基准年度
      var isFirst = true;
      if (baseYear % 2 == 0) {
        isFirst = false;
        baseYear = that.targetyear - 1;
      }

      // 数据
      var pList2 = [];
      var sList2 = [];
      var pList3 = [];
      var sList3 = [];

      var lineMediaBase = {};
      var lineElectrBase = {};
      if (this.chartDataFinance.length > 0) {
        var lstMediaProfit = [];
        var lstMediaSales = [];
        var lstElectrProfit = [];
        var lstElectrSales = [];

        // 一般是两组 音像一组 电子一组
        for (var record of this.chartDataFinance) {
          if (this.targetprovince.length > 0 && this.targetprovince.indexOf(record.provincename) == -1) {
            continue;
          }

          if (record.type == "音像") {
            pList2.push(record.provincename);
            lstMediaProfit.push(record[(isFirst ? "first" : "second") + "profit" + baseYear] * 1);
            lstMediaSales.push(record[(isFirst ? "first" : "second") + "sales" + baseYear] * 1);
          } else {
            pList3.push(record.provincename);
            lstElectrProfit.push(record[(isFirst ? "first" : "second") + "profit" + baseYear] * 1);
            lstElectrSales.push(record[(isFirst ? "first" : "second") + "sales" + baseYear] * 1);
          }
        }
        lineMediaBase[that.targetyear + "年音像销售收入"] = lstMediaSales;
        lineMediaBase[that.targetyear + "年音像利润(税后)总额"] = lstMediaProfit;

        lineElectrBase[that.targetyear + "年电子销售收入"] = lstElectrSales;
        lineElectrBase[that.targetyear + "年电子利润(税后)总额"] = lstElectrProfit;
      }

      Object.keys(lineMediaBase).forEach((item) => {
        var isSort = true;
        if (item.indexOf("利润") > -1) {
          isSort = false;
        }
        var series = {
          realtimeSort: isSort,
          name: item,
          type: "bar",
          barGap: "-100%",
          label: {
            show: true,
            position: "insideLeft",
            offset: isSort ? [200, 2] : [50, 2],
            distance: 15,
            align: "left",
            verticalAlign: "middle",
            // rotate: 90,
            formatter: "{c}",
            fontSize: 12,
            rich: {
              name: {},
            },
          },
          emphasis: {
            focus: "series",
          },
          data: lineMediaBase[item],
        };
        sList2.push(series);
      });

      Object.keys(lineElectrBase).forEach((item) => {
        var isSort = true;
        if (item.indexOf("利润") > -1) {
          isSort = false;
        }
        var series = {
          realtimeSort: isSort,
          name: item,
          type: "bar",
          barGap: "-100%",
          label: {
            show: true,
            position: "insideLeft",
            offset: isSort ? [200, 2] : [50, 2],
            distance: 15,
            align: "left",
            verticalAlign: "middle",
            // rotate: 90,
            formatter: "{c}",
            fontSize: 12,
            rich: {
              name: {},
            },
          },
          emphasis: {
            focus: "series",
          },
          data: lineElectrBase[item],
        };
        sList3.push(series);
      });

      var Params2 = {
        title: "音像经营数据",
        subtext: "省局数量：" + pList2.length,
        provinceList: pList2,
        series: sList2,
      };
      this.drawAnimeBar("chart_province_2", Params2);

      var Params3 = {
        title: "电子经营数据",
        subtext: "省局数量：" + pList3.length,
        provinceList: pList3,
        series: sList3,
      };
      this.drawAnimeBar("chart_province_3", Params3);

      setTimeout(function () {
        that.changeAndRedraw();
      }, 1000);
    },
    changeAndRedraw() {
      var that = this;
      var baseYear = that.targetyear; // 基准年度
      var isFirst = true;
      if (baseYear % 2 == 0) {
        isFirst = false;
        baseYear = that.targetyear - 1;
      }

      var sList2 = [];
      var sList3 = [];
      var lineMediaBase = {};
      var lineElectrBase = {};
      if (this.chartDataFinance.length > 0) {
        var lstMediaProfit = [];
        var lstMediaSales = [];
        var lstElectrProfit = [];
        var lstElectrSales = [];

        // 一般是两组 音像一组 电子一组
        for (var record of this.chartDataFinance) {
          if (this.targetprovince.length > 0 && this.targetprovince.indexOf(record.provincename) == -1) {
            continue;
          }
          if (record.type == "音像") {
            lstMediaProfit.push(record[(isFirst ? "first" : "second") + "profit" + baseYear] * 1);
            lstMediaSales.push(record[(isFirst ? "first" : "second") + "sales" + baseYear] * 1);
          } else {
            lstElectrProfit.push(record[(isFirst ? "first" : "second") + "profit" + baseYear] * 1);
            lstElectrSales.push(record[(isFirst ? "first" : "second") + "sales" + baseYear] * 1);
          }
        }
        lineMediaBase[that.targetyear + "年音像销售收入"] = lstMediaSales;
        lineMediaBase[that.targetyear + "年音像利润(税后)总额"] = lstMediaProfit;

        lineElectrBase[that.targetyear + "年电子销售收入"] = lstElectrSales;
        lineElectrBase[that.targetyear + "年电子利润(税后)总额"] = lstElectrProfit;
      }

      Object.keys(lineMediaBase).forEach((item) => {
        var isSort = true;
        if (item.indexOf("利润") > -1) {
          isSort = false;
        }
        var series = {
          realtimeSort: isSort,
          name: item,
          type: "bar",
          data: lineMediaBase[item],
        };
        sList2.push(series);
      });

      Object.keys(lineElectrBase).forEach((item) => {
        var isSort = true;
        if (item.indexOf("利润") > -1) {
          isSort = false;
        }
        var series = {
          realtimeSort: isSort,
          name: item,
          type: "bar",
          data: lineElectrBase[item],
        };
        sList3.push(series);
      });

      var myChart = echarts.init(document.getElementById("chart_province_2"), this.chartTheme);
      myChart.setOption({
        series: sList2,
      });
      var myChart = echarts.init(document.getElementById("chart_province_3"), this.chartTheme);
      myChart.setOption({
        series: sList3,
      });
    },
    drawAnimeBar: function (id, chartParams) {
      console.log("drawAnimeBar", chartParams);
      let that = this;
      this.disposeChart(id);

      var maxCount = this.targetlimit;
      if (maxCount == 0) {
        maxCount = chartParams.provinceList.length - 1;
      }

      var myChart = echarts.init(document.getElementById(id), this.chartTheme);
      var option = {
        title: {
          text: chartParams.title,
          subtext: chartParams.subtext,
          left: "center",
          top: 50,
        },
        tooltip: {
          trigger: "item",
        },
        grid: { top: "15%", left: "27%" },
        legend: {
          show: true,
          bottom: "10",
        },
        xAxis: {
          gridIndex: 0,
          max: "dataMax",
          min: 0,
          axisLabel: {
            show: false,
            interval: 5,
            hideOverlap: true,
            showMaxLabel: true,
          },
          position: "top",
          name: "万元",
        },
        yAxis: {
          type: "category",
          gridIndex: 0,
          data: chartParams.provinceList,
          inverse: true,
          animationDuration: 300,
          animationDurationUpdate: 300,
          max: maxCount,
        },
        // 数据值
        series: chartParams.series,
        // 右上角工具箱
        toolbox: {
          show: true,
          feature: {
            // // dataView: {show: true, readOnly: true},
            // myTool1: {
            //   // 自定义按钮 danielinbiti,这里增加，selfbuttons可以随便取名字
            //   show: true, // 是否显示
            //   title: "搜索筛选", // 鼠标移动上去显示的文字
            //   icon: that.imgUrldata, // 图标
            //   option: {},
            //   onclick: function (option1) {
            //     // 点击事件,这里的option1是chart的option信息
            //     that.backEcharts(id, myChart, option1);
            //   },
            // },

            saveAsImage: { show: true, icon: that.imgUrldownload }, //,iconStyle:{color:'#BAFBFB'}
          },
          top: 50,
          right: 10,
        },
        animationDuration: 0,
        animationDurationUpdate: 1000,
        animationEasing: "linear",
        animationEasingUpdate: "linear",
      };
      // 绘制图表
      myChart.setOption(option);
      myChart.on("click", function (params) {
        console.log("clickparams==", id, params);
        var title = params.seriesName.substr(5);
        if (id == "chart_province_1") {
          that.table1colname = title;
        } else if (id == "chart_province_2") {
          that.table2colname = title;
        } else if (id == "chart_province_3") {
          that.table3colname = title;
        }
        getProvinceFinanceDetail({
          type: id,
          firstyear: this.searchFirstYear,
          targetyear: params.seriesName,
          province: params.name,
        }).then((res) => {
          that.datalist = res.data;
          that.bakData[id] = res.data;
          that.createDataHtml(id, res.data);
          that.backEcharts(id, myChart, params);
        });

        console.log(params);
      });
      this.chartResize(myChart);
    },
    chartResize(myChart) {
      myChart.resize();
    },
    backEcharts(id, myChart, option) {
      var disb = $("#" + id + "_table").css("display");
      if (disb == "none") {
        $("#" + id + "_table").fadeIn(500);
        $("#" + id).css("width", $("#" + id).width());
        $("#" + id).css("display", "none");
        $("#sel_" + id).css("display", "none");
      } else {
        $("#" + id + "_table").css("display", "none");
        $("#" + id).fadeIn(500);
        $("#sel_" + id).fadeIn(500);
      }
    },
    clearQueryFilerN() {
      //清除查询条件
      for (var key in this.queryFilterN) {
        this.queryFilterN[key] = "";
      }
      //清除排序
      for (var key in this.querySort["chart_n"]) {
        this.querySort["chart_n"][key] = "sort";
      }
    },
    setQueryVisible(id) {
      this.queryVisible[id] = !this.queryVisible[id];
    },
    goFilterList(id) {
      console.log("goFilterList", this.query);
      var query = this.query[id];
      var datalist = this.bakData[id];

      var filtedData = datalist.filter((item) => {
        return (
          item.provincename.indexOf(query.provincename) > -1 &&
          item.name.indexOf(query.name) > -1 &&
          (item.value + "").indexOf(query.value) > -1
        );
      });
      this.createDataHtml(id, filtedData);
    },
    formatEmpty(val) {
      if (val == undefined || val == "" || val == null || val == "null") {
        return "-";
      } else {
        return val;
      }
    },
  },
  created: function () {
    let that = this;
    window.addEventListener("resize", () => {
      that.initCharts();
    });
    that.initCharts();
  },
};
</script>

<style lang="scss" scoped>
.echart_table {
  width: 90%;
  overflow: hidden;
  display: none;
  margin-top: 60px;
}

.tabletemp {
  width: 90%;
  height: 760px;
}

.echart_table table tbody {
  display: block;
  height: 660px;
  overflow-y: auto;
}
.echart_table .tabletemp th {
  padding: 0.24rem;
}
.searchFilerCls {
  padding-top: 3px;
}
</style>



// WEBPACK FOOTER //
// ProvinceFinance.vue?0c0c8016